<template>
  <div id="subject-list-content">
    <div class="subject-list">
      <table class="table table-bordered ui-table ts-table">
        <thead>
          <tr>
            <th class="text-center">{{ $t('khmerSecondarySchedule.no') }}</th>
            <th>{{ $t('khmerSecondarySchedule.teacherName') }}</th>
            <th class="text-center">
              {{ $t('khmerSecondarySchedule.teacherSubjectCode') }}
            </th>
            <th>{{ $t('khmerSecondarySchedule.className') }}</th>
            <th class="text-center">
              {{ $t('khmerSecondarySchedule.totalHours') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(subject, key, index) in subjects">
            <tr style="background-color: #F9FBFB">
              <td colspan="5" class="text-primary ts-font-bold">
                {{ getOjectKey(subject) }}
              </td>
            </tr>
            <tr v-for="(item, index) in getValueObject(subject)">
              <td class="text-center">{{ index + 1 }}</td>
              <td>{{ item.teacher_name }}</td>
              <td class="text-center">{{ item.subject_code }}</td>
              <td>{{ item.classes }}</td>
              <td class="text-center">{{ item.total_hours }}</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'subject-table',
  data() {
    return {
      loading: false
    }
  },
  created() {},
  computed: {
    ...mapState('khmerSecondarySchedule', ['subjects'])
  },
  methods: {
    getOjectKey(value) {
      return Object.keys(value).reduce((init, value) => (init = value), null)
    },
    getValueObject(obj) {
      return Object.values(obj).flat()
    }
  }
}
</script>
<style lang="scss" scoped>
#subject-list-content {
  max-height: 35vh;
  overflow-y: scroll;
  overflow-x: scroll;
}

.subject-list {
  max-height: 34vh;
  width: 100%;

  .table > thead > tr > th {
    position: sticky;
    top: 0;
    z-index: 100;
  }
  table th,
  td {
    padding: 8px 12px;
    vertical-align: middle !important;
    white-space: nowrap;
  }
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #dddedf;
}
div::-webkit-scrollbar-thumb:hover {
  background: #818485;
}
</style>
